/**
 * Calculates the updated workDays value.
 * @checked: true/false state of the checkbox
 * @workDays: current work days value
 * @weekDay: option state obj corresponding to the clicked checkbox item
 */
var calculateUpdatedWorkDays = function (checked, workDays, weekDay) { return (checked ? workDays + weekDay.key : workDays - weekDay.key); };
export default calculateUpdatedWorkDays;
//# sourceMappingURL=calculateUpdatedWorkDays.js.map